export const SUCCESS_KEY = "success";
export const WARNING_KEY = "warning";
export const ERROR_KEY = "error";

export const CLICK_SUMMRAY_TEXT="Click to view Summary ...";
export const FORM_SUBMISSION_SUCCESS = "Details are successfully submitted";
export const FAILURE_MESSAGE = "Something went wrong, please try again";

export const SUBMIT_BUTTON_TEXT = "Submit";
export const SAVE_BUTTON_TEXT = "Save";
export const APPLY_BUTTON_TEXT = "Apply";
export const CANCEL_BUTTON_TEXT = "Cancel";
export const DELETE_BUTTON_TEXT = "Delete";
export const EDIT_BUTTON_TEXT = "Edit";


export const ACTIVE_STATUS = "active";
export const COMPLETED_STATUS = "completed";
export const IMAGE_UPLOAD_ERROR =
  "Something went wrong in image upload, please try again";
export const FILE_SIZE_MSG = "Size: 2MB, pdf.";
export const NUMBER_ONLY_REGEX = /^[0-9\b]+$/;
export const LETTERS_ONLY_REGEX = /^[a-zA-Z \b]+$/;
export const DOB = new RegExp(
  "^(3[01]|[12][0-9]|0[1-9])/(1[0-2]|0[1-9])/[0-9]{4}$"
);
export const PAGE_SIZE_ARRAY = [10, 15, 20, 25, 50, 100];
export const emailValidation = (email) => {
  const regex = new RegExp(
    "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
  );
  return !(!email || regex.test(email) === false);
};
export const specialCharValidation = (input) => {
  const regex = /^[a-zA-Z \b]+$/;
  return !input || !regex.test(input) === false;
};

export const VERSION = `v1/`
export const USER_PATH = `${VERSION}users`;
export const ADMIN_PATH = `${VERSION}admin`;

export const ACTIVE_PROJECT = "ACTIVE";
export const SELECT_MONTH = "Select Month/Year";

export const NEXT_BUTTON_TEXT = "Next month";
export const PREVIOUS_BUTTON_TEXT = "Previous month";
export const DATEPICKER_MIN_DATE = "2020-01-01";
export const DATEPICKER_MAX_DATE = "2031-01-01";

export const SNACKBAR_400_MSG ="Bad Request – Error 400";
export const SNACKBAR_401_MSG ="HTTP 401 Error – Unauthorized";
export const SNACKBAR_403_MSG ="You are not authorized to view this page";
export const SNACKBAR_404_MSG ="We can’t find the page you’re looking for";
export const SNACKBAR_409_MSG ="Request could not be processed";
export const SNACKBAR_500_MSG ="Internal Server Error";
export const SNCACKBAR_DEFAULT_MSG="Sorry Something went wrong please try again!";
export const SNACKBAR_SUCCESS_MSG ="Successfully Processed Request";
export const SNACKBAR_201_MSG ="Successfully created";
export const SNACKBAR_204_MSG ="Successfully deleted";

export const SNACKBAR_NODATA_MSG ="Sorry No data for this date";
export const EXPAND_TEXT="Click To expand";

export const DESCRIPTION_TEXT="Description :-"

export const ALL_KEY = "All";
export const COLUMNS_TEXT = "Columns";

export const HOLD_ACTION = "hold";
export const UNHOLD_ACTION = "activate";

export const PROCEED_BTN_TEXT = "Proceed";

export const NEW_SUB_STATUS = "new";
export const GENERIC_GROUPBY = "subStatus";
export const COUNT_OPERATION = "count";
export const TIMEZONE_SUFFIX = "%2B05:30";
export const BACK_BTN_TEXT = "Go Back";
